export default __webpack_public_path__ + "static/media/uranium_cell.9d84bc9f.png";